const module = {
  config: {
    name: 'news-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Forum',
    layout: true
  },
  routes: [
    { name: 'news', label: 'Berita', icon: 'ri-file-text-line', path: '/news', component: () => import('./news.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component: () => import('./users.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/news/_index.js